import React from 'react';
import { Navigate, Routes, Route } from 'react-router-dom';
import HomePAge from './pages/HomePAge';
import SecondPage from './pages/SecondPage';
import ThirthPage from './pages/ThirthPage';
import ProtectedRoute from './components/ProtectedRoute';
import LoginPage from './pages/LoginPage';
import MainLayout from './components/MainLayout';
import ProfilePage from './pages/ProfilePage';
import CreateVideoPage from './pages/CreateVideoPage';
import TemplateDetailPage from './pages/TemplateDetailPage';
import RunDetailPage from './pages/RunDetailPage';
import AdminPage from './pages/AdminPage';
import VideosPage from './pages/VideosPage';
import VideoMergePage from './pages/VideoMergePage';
import AiVideosPage from './pages/AiVideosPage';
import LivaxuLandingPage from './pages/LivaxuLandingPage';
import AdminSalesLoginPage from './pages/AdminSalesLoginPage';
import SalesPanelPage from './pages/SalesPanelPage';

function App() {
  return (
    <Routes>
      <Route path="/" element={<LivaxuLandingPage />} />
      <Route path="/video-creator-login" element={<LoginPage />} />
      <Route path="/admin-sales-login" element={<AdminSalesLoginPage />} />
      <Route path="/sales-admin" element={<Navigate to="/sales-admin/dashboard" replace />} />
      <Route path="/sales-admin/:section" element={<SalesPanelPage />} />

      <Route element={<ProtectedRoute />}> 
        <Route element={<MainLayout />}>
          <Route path="/video-creator" element={<HomePAge />} />
          <Route path="/videos" element={<VideosPage />} />
          <Route path="/video-merge" element={<VideoMergePage />} />
          <Route path="/ai-videos" element={<AiVideosPage />} />
          <Route path="/second-page" element={<SecondPage />} />
          <Route path="/thirt-page" element={<ThirthPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/create-video" element={<CreateVideoPage />} />
          <Route path="/templates/:id" element={<TemplateDetailPage />} />
          <Route path="/runs/:id" element={<RunDetailPage />} />
        </Route>
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
